import MembershipRefinement from "./MembershipRefinement";

export default function MembershipFilter(props) {
  return (
    <div className="checkboxes-large">
      <MembershipRefinement
        limit={20}
        operator="or"
        attribute="directory_user_type"
        values={[
            { label: 'Individuals', value: 'Individuals' },
            { label: 'Companies', value: 'Companies' },
            { label: 'Community Members', value: 'Community Members' },
            { label: 'Manufacturers Suppliers', value: 'Manufacturers Suppliers' },
        ]} />

    </div>
  );
}
